/**
 * @file The Component contains the whole Configuration information for user to review their choices
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import React from 'react';
import { Button, Checkbox, Row, Col, Form, Icon } from 'antd';
//components
import Navigation from '../../../Navigation/Navigation';
//funcs & data
import { generateWinResponseFile } from '../../../../FileGenerator/FileGenerator';
import {
    state2PrefixMap,
    state2CommentMap,
    summaryStructure,
} from '../../../../Utils/WindowsDataLoader';

import { generateSummary, triggerLambda } from '../../../../Utils/utils';
import {
    CUSTOM_INSTALL,
    EXPRESS_INSTALL,
    M11_6_09,
    M11_6_06,
    M11_6_03,
    M11_5_12,
    M11_5_09,
    M11_5_06,
    M11_5_03,
    M11_4_12,
} from '../../../../Utils/Constants';
//css
import 'antd/dist/antd.css';
import '../../../../Utils/CommonCss.css';

class Summary extends React.Component {
    backStep = () => {
        this.props.backStep();
    };

    /**
     * To generate the Option.txt and download it locally
     */
    downloadTxtFile = () => {
        const element = document.createElement('a');
        let res = generateWinResponseFile(
            this.props,
            state2PrefixMap,
            state2CommentMap
        );

        let fileName;
        switch (this.props.useMode) {
            case CUSTOM_INSTALL:
                switch (this.props.useVersion) {
                    case M11_4_12:
                        fileName = 'response_custom_m11_4_12.ini';
                        break;
                    case M11_5_03:
                        fileName = 'response_custom_m11_5_03.ini';
                        break;
                    case M11_5_06:
                        fileName = 'response_custom_m11_5_06.ini';
                        break;
                    case M11_5_09:
                        fileName = 'response_custom_m11_5_09.ini';
                        break;
                    case M11_5_12:
                        fileName = 'response_custom_m11_5_12.ini';
                        break;
                    case M11_6_03:
                        fileName = 'response_custom_m11_6_03.ini';
                        break;
                    case M11_6_06:
                        fileName = 'response_custom_m11_6_06.ini';
                        break;
                    case M11_6_09:
                        fileName = 'response_custom_m11_6_09.ini';
                        break;
                    default:
                }
                break;
            case EXPRESS_INSTALL:
                switch (this.props.useVersion) {
                    case M11_4_12:
                        fileName = 'response_express_m11_4_12.ini';
                        break;
                    case M11_5_03:
                        fileName = 'response_express_m11_5_03.ini';
                        break;
                    case M11_5_06:
                        fileName = 'response_express_m11_5_06.ini';
                        break;
                    case M11_5_09:
                        fileName = 'response_express_m11_5_09.ini';
                        break;
                    case M11_5_12:
                        fileName = 'response_express_m11_5_12.ini';
                        break;
                    case M11_6_03:
                        fileName = 'response_express_m11_6_03.ini';
                        break;
                    case M11_6_06:
                        fileName = 'response_express_m11_6_06.ini';
                        break;
                    case M11_6_09:
                        fileName = 'response_express_m11_6_09.ini';
                        break;
                    default:
                }
                break;
            default:
        }

        let file = new File([res], fileName, {
            type: 'text/plain',
        });

        element.href = URL.createObjectURL(file);
        element.download = file.name;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();

        let info = {
            fileName: file.name,
            companyName: this.props.getOriginState('companyName'),
            os: this.props.useOs,
            mode: this.props.useMode,
            version: this.props.useVersion,
        };

        //upload to s3
        triggerLambda(
            info,
            function (response) {
                console.log('Success!');
            },
            function (error) {
                console.error(error);
            }
        );
    };

    render() {
        return (
            <Form className="form">
                <Row type="flex" align="top">
                    <Col
                        span={4}
                        className={['colNav', 'winSummaryNavHeight'].join(' ')}
                    >
                        <p className="headlineTop">Steps</p>
                        <Navigation
                            setOriginState={this.props.setOriginState}
                            getOriginState={this.props.getOriginState}
                            steps={this.props.steps}
                            deepestStep={this.props.deepestStep}
                            useOs={this.props.useOs}
                        />
                    </Col>

                    <Col span={18} className="colContent">
                        <p className="headlineTop">Summary</p>
                        <div>
                            <div className="summaryContainer">
                                {this.props.useMode === CUSTOM_INSTALL
                                    ? generateSummary(
                                          summaryStructure,
                                          this.props
                                      )
                                    : generateSummary(
                                          summaryStructure,
                                          this.props
                                      )}
                            </div>
                            <Checkbox
                                onChange={(e) => {
                                    this.props.setOriginState(
                                        'forceReboot',
                                        e.target.checked
                                    );
                                }}
                                checked={this.props.getOriginState(
                                    'forceReboot'
                                )}
                            >
                                Automatically restart this computer if needed
                                during installation
                            </Checkbox>
                        </div>
                    </Col>
                </Row>
                <div className="buttonBar">
                    <div className="description">
                        You are creating a configuration file for
                        <img
                            src={require('../../../../assets/Icons/Windows.png')}
                            alt="Operating System"
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            className="buttonBack"
                            type="default"
                            onClick={this.backStep}
                        >
                            Back
                        </Button>
                        <Button
                            className="buttonNext"
                            type="primary"
                            onClick={this.downloadTxtFile}
                        >
                            <Icon type="vertical-align-bottom" />
                            Download File
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

export default Summary;
